import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl sm:text-3xl font-bold mb-4">
              <span className="text-white">NEX</span>
              <span className="text-secondary">EDZ</span>
            </h3>
            <p className="text-gray-400 mb-4 text-sm sm:text-base">
              Empowering Bharat through Education, Innovation, and Digital Services.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/share/17eckxGt9w/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-secondary transition text-xl sm:text-2xl">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="https://youtube.com/@nexedz-selfreliantbharat" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-secondary transition text-xl sm:text-2xl">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="https://www.instagram.com/nexedz_private_limited" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-secondary transition text-xl sm:text-2xl">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/company/nexedz" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-secondary transition text-xl sm:text-2xl">
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg sm:text-xl font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm sm:text-base">
              <li>
                <Link to="/" className="text-gray-400 hover:text-secondary transition">
                  Home
                </Link>
              </li>
              <li>
                <a href="/who-we-are" className="text-gray-400 hover:text-secondary transition">
                  Who We Are
                </a>
              </li>
              <li>
                <a href="/#" className="text-gray-400 hover:text-secondary transition">
                  Refund Policy
                </a>
              </li>
              <li>
                <a href="/#" className="text-gray-400 hover:text-secondary transition">
                  FAQ
                </a>
              </li>
              <li>
                <a href="/privacy-policy" className="text-gray-400 hover:text-secondary transition">
                  Privacy Policy
                </a>
              </li>
              {/* <li>
                <Link to="/business-verticals" className="text-gray-400 hover:text-secondary transition">
                  Business Verticals
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h4 className="text-lg sm:text-xl font-bold mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm sm:text-base">
              <li>
                <a href="/edge-infotech" className="text-gray-400 hover:text-secondary transition">
                  EDGE INFOTECH
                </a>
              </li>
              <li>
                <a href="/edge-paisa" className="text-gray-400 hover:text-secondary transition">
                  Edge Paisa
                </a>
              </li>
              <li>
                <a href="/rojgar-mitra" className="text-gray-400 hover:text-secondary transition">
                  Rojgar Mitra
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg sm:text-xl font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm sm:text-base">
              <li className="flex items-start text-gray-400">
                {/* <i className="fas fa-map-marker-alt mt-1 mr-3 text-secondary"></i> */}
                {/* <span>26/6 Paris Town Batala Road, Amritsar</span> */}
              </li>
              <li className="flex items-center text-gray-400">
                <i className="fas fa-phone mt-1 mr-3 text-secondary"></i>
                <span>+91 8146883319</span>
              </li>
              <li className="flex items-center text-gray-400">
                <i className="fas fa-envelope mt-1 mr-3 text-secondary"></i>
                <span className="break-all">support@nexedz.org</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm sm:text-base">
            &copy; {new Date().getFullYear()} NEXEDZ Private Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;